import type {
	CreateScheduleModel,
	HTTPValidationError,
	ScheduleModel,
} from '@/shared/generated'

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

/**
 * Schedule
 */
export function useCreateScheduleMutation() {
	const queryClient = useQueryClient()

	return useMutation<ScheduleModel, HTTPValidationError, CreateScheduleModel>({
		mutationFn: (payload) => client.schedules.createSchedule(payload),
		onSuccess() {
			queryClient.invalidateQueries({
				queryKey: ['schedules'],
			})
		},
	})
}
export function useDeleteScheduleMutation() {
	const queryClient = useQueryClient()

	return useMutation<void, HTTPValidationError, string>({
		mutationFn: (scheduleId) => client.schedules.deleteSchedule({ scheduleId }),
		onSuccess() {
			queryClient.invalidateQueries({
				queryKey: ['schedules'],
			})
		},
	})
}
export function useUpdateScheduleMutation() {
	const queryClient = useQueryClient()

	return useMutation<ScheduleModel, HTTPValidationError, CreateScheduleModel>({
		mutationFn: (payload) =>
			client.schedules.updateSchedule({ scheduleId: payload.id! }, payload),
		onSuccess() {
			queryClient.invalidateQueries({
				queryKey: ['schedules'],
			})
		},
	})
}
